import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDELETE_generalNoteMutation, useGET_generalNotesQuery } from 'redux/api/generalNotesApi'
import GeneralNoteForm from 'components/organisms/forms/GeneralNoteForm'
import { ActionType, RoleType } from 'types'
import DialogPopup from 'components/molecules/DialogPopup'
import { Accordion, AccordionDetails, AccordionSummary, Button } from '@mui/material'
import { Delete, ExpandMore } from '@mui/icons-material'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import { formatDateTime } from 'utils/helpers'

interface IProps {
  action: ActionType
  assignmentId?: string
  viewOnly: boolean
  userRole: RoleType
}

const slideProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: { enter: 225, exit: 195 }
};

const GeneralNotes: FC<IProps> = ({ assignmentId }) => {
  const { t } = useTranslation()

  const [createPopupOpen, setCreatePopupOpen] = useState(false)

  const [
    deleteEntity,
    { isSuccess: deleteSuccess, error: deleteError },
  ] = useDELETE_generalNoteMutation()

  useErrorAlert(deleteError)
  useSuccessAlert(deleteSuccess ? t('alerts.entity-removed',{entity: t('common.all-purpose-item')}) : '')

  const { isLoading: isLoading, data: generalNotes } = useGET_generalNotesQuery({assignment_id: assignmentId})
  const data = generalNotes?.results ?? []


  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <Button
          variant='contained'
          color='success'
          onClick={() => {
            setCreatePopupOpen(true)
          }}
          sx={{ marginLeft: '5px' }}
        >
          {t('common.add-all-purpose-item')}
        </Button>
      </div>

      {data.map((note, index) => 
                          <Accordion 
                            TransitionProps={slideProps}
                            key={note.id} >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                 {t('common.all-purpose-item')}: {note.title}
                            </AccordionSummary>
                            <AccordionDetails>  
                                <>
                                  <span dangerouslySetInnerHTML={{ __html: note.text }} />
                                  <div style={{ marginTop: '10px' }}>{t('common.show-from-datetime')}: <b>{formatDateTime(note.show_from_datetime) }</b></div>
                                  <div style={{ marginTop: '10px' }}>{t('common.show-to-datetime')}: <b>{formatDateTime(note.show_from_datetime)}</b></div>
                                  <div style={{ marginTop: '10px' }}>{t('common.recipients')}: <b>{note.recipients.map(r => r.title).join(', ')}</b></div>

                                  <div style={{ marginTop: '20px' }}>
                                    <Button
                                      size='small'
                                      variant='contained'
                                      color='error'
                                      className='small-button'
                                      onClick={() => deleteEntity({assignment_id: assignmentId, id: note.id.toString()})}
                                    >
                                      <Delete />
                                      {`${t('common.delete')}`}
                                    </Button>
                                  </div>
                                </>   

                            </AccordionDetails>
                          </Accordion>  
                        ) 
        }   


      <DialogPopup
        title={t('common.add-all-purpose-item')}
        open={createPopupOpen}
        onClose={() => setCreatePopupOpen(false)}
        popupWidth={'1000px'}
      >
        <GeneralNoteForm 
          assignmentId={assignmentId}
          onCreate={() => {
            setCreatePopupOpen(false)
          }}
        />
      </DialogPopup>
    </>
  )
}

export default GeneralNotes
